import { AuthProviders } from '../features/SignIn/signin.types';
import { Apple, Facebook, Google, Phone } from 'grommet-icons';

const ProviderIcon = (providerId: AuthProviders): JSX.Element | null => {
  switch (providerId) {
    case AuthProviders.APPLE:
      return <Apple color="plain" size="12px" />;
    case AuthProviders.FACEBOOK:
      return <Facebook color="plain" size="12px" />;
    case AuthProviders.GOOGLE:
      return <Google color="plain" size="12px" />;
    case AuthProviders.PHONE:
      return <Phone fill="#000000" size="14px" />;
    default:
      return null;
  }
};

export default ProviderIcon;
